<template>
  <a-config-provider :locale="locale.zhCN">
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>
<script>
import zh from 'ant-design-vue/lib/locale-provider/zh_CN'
import en from 'ant-design-vue/lib/locale-provider/en_US'
export default {
  data () {
    return {
      locale: {
        zhCN: zh,
        enUS: en
      },
      socket: ''
    }
  },
  beforeDestroy () {
    if (this.socket) {
      this.socket.disconnect()
      this.socket.close()
      this.socket = ''
    }
  }
}
</script>

<style lang="less">

</style>
